

































import Vue from 'vue';
import BillingService from '~/services/BillingService';
import BillingModal from './BillingModal.vue';

export default Vue.extend({
    name: 'CancelButton',
    components: {
        BillingModal,
    },
    props: {
        subscriptionId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showDialog: false,
            completed: false,
            loading: false,
            error: false,
        };
    },
    methods: {
        toggleDialog(open?: boolean) {
            if (this.completed) this.$router.go(0);
            else this.showDialog = typeof open !== 'undefined' ? open : !this.showDialog;
        },
        async cancelSubscription() {
            this.loading = true;
            try {
                const res = await BillingService.cancelSubscription(this.subscriptionId);

                if (res) this.completed = true;
                else this.error = true;
            } catch {
                this.error = true;
            } finally {
                this.loading = false;
            }
        },
    },
});
